/**
 * Small helpers for reading unknown JSON / API blobs as records and strings.
 * Use one canonical property name per field — no alternate-key fallbacks.
 */

export function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === "object" ? (v as Record<string, unknown>) : null;
}

/** Trimmed non-empty string, or undefined when missing / blank. */
export function trimmedString(v: unknown): string | undefined {
  if (typeof v !== "string") return undefined;
  const t = v.trim();
  return t.length ? t : undefined;
}

/** Read a single string field from a record (canonical key only). */
export function trimmedStringField(
  rec: Record<string, unknown>,
  key: string,
): string | undefined {
  return trimmedString(rec[key]);
}

/** Non-empty array of trimmed strings, or undefined. */
export function trimmedStringArray(v: unknown): string[] | undefined {
  if (!Array.isArray(v) || v.length === 0) return undefined;
  const out = v
    .map((x) => (typeof x === "string" ? x.trim() : ""))
    .filter(Boolean);
  return out.length ? out : undefined;
}
